<template>
  <div id="container-customer-view-data">
    <container-customer-form
      mode="view"
      :itemId="itemId"
    >
    </container-customer-form>
  </div>
</template>

<script>

import ContainerCustomerForm from "./ContainerCustomerForm";
import { DeviceInfoMixin } from "@/mixins";


export default {
  components: {
    ContainerCustomerForm,
  },
  mixins: [DeviceInfoMixin],
  data() {
    return {
      itemId: this.$route.params.itemId
    }
  },
  created() {
    this.onResize();
  },
  computed: {
  },
  watch: {
    onChangeWindowSize() {
      this.onResize();
    },
  },
  methods: {
    /**
     *  iPhone,iPadでのレフトメニュー表示制御.
     */
    onResize() {
      this.$nextTick(() => {
        if ( ["iPhone", "iPad"].includes( this.getDeviceInfo().deviceType )) {
          // iPhone, iPad はメニューを表示しない。
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
          this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
        } else {
          this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
          this.$store.dispatch("updateVerticalNavMenuWidth", "default");
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
</style>